import { createListingApi } from '@eastcoal/api/trade/listingMember/createListing'
import { queryListingApi } from '@eastcoal/api/trade/listingMember/queryListing'
import { updateListingApi } from '@eastcoal/api/trade/listingMember/updateListing'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { useNavigate } from '@eastcoal/router/exports/react-router'

import { ListingDepositMethod } from '../enums/DepositMethod'

import { kindEffects } from './effects/kindEffects'
import { pricingMethodEffect } from './effects/pricingMethod'
import { ListingFormExposedProps, ListingFormProps } from './interface'
import { listingSchema } from './schemas'

const readApi: ListingFormProps['readApi'] = ({ id }) => {
  return {
    api: async () => queryListingApi({ id }),
    ready: !!id,
    refreshDeps: [id]
  }
}
const effects: ListingFormProps['effects'] = () => {
  kindEffects()
  pricingMethodEffect()
}

export const ListingForm = ({ mode }: ListingFormExposedProps) => {
  const { id: memberId } = useAuthStore(state => state.member)
  const navigator = useNavigate()

  return (
    <PageContainer>
      <CrudForm
        createApi={createListingApi}
        effects={effects}
        mode={mode}
        name='listingForm'
        readApi={readApi}
        schema={listingSchema}
        updateApi={updateListingApi}
        actions={[
          <BackButton key='backButton' />,
          <SaveButton key='saveButton' />,
          <SubmitButton key='submitButton' />
        ]}
        initialValues={{
          memberId,
          depositMethod: ListingDepositMethod.FIXED,
          depositQuantity: 0
        }}
        layout={{
          labelWidth: 80,
          colon: false
        }}
        onSuccess={() => navigator(-1)}
      />
    </PageContainer>
  )
}
